import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import loginIcon from '../../assets/images/login.png'
import newUserIcon from '../../assets/images/newuser.png'
import Card from '../../components/Card'
import scrollUtils from '../../util/scroll'

export default function () {
	useEffect(() => {
		scrollUtils.toTop()
	}, [])

	return (
		<div className="flex flex-col gap-8 md:px-12 py-8 lg:px-24 py-16">
			<Card className="flex flex-col gap-8">
				<h1 className="text-slate-800">Selecione uma opção</h1>

				<div className="flex flex-col md:flex-row gap-12 justify-center">
					<Link
						className="flex flex-col items-center border border-slate-300 bg-slate-100 rounded-md p-6 hover:bg-slate-200 cursor-pointer gap-3 text-slate-700"
						to="/signup"
					>
						<img src={newUserIcon} className="h-16" />

						<span className="font-semibold text-center">
							Quero criar uma nova conta
						</span>
					</Link>

					<Link
						className="flex flex-col items-center border border-slate-300 bg-slate-100 rounded-md p-6 hover:bg-slate-200 cursor-pointer gap-3 text-slate-700"
						to="/login"
					>
						<img src={loginIcon} className="h-16" />

						<span className="font-semibold text-center">
							Já tenho usuário e senha
						</span>
					</Link>
				</div>
			</Card>
		</div>
	)
}
